import isStringDefined from './is-string-defined';

export default function isStringArrayDefined(str: any): str is string[] {
  try {
    return Array.isArray(str) && str.every(isStringDefined);
  } catch (e) {
    return false;
  }
}
